module.exports = __webpack_public_path__ + "static/img/MRT-Ultra-SATA-Controller-Card-Reverse-Side.b6a7d3f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product_images/MRT-Ultra-SATA-Controller-Card-Reverse-Side.jpg
// module id = SRuH
// module chunks = 1